import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'

import { LocaleModule } from 'common/locale'

import { UtilCommonModule } from '../util'
import { FileConflictModalComponent } from './components/fileConflictModal.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LocaleModule.forChild(),
    UtilCommonModule,
    NgbTooltipModule,
    FileConflictModalComponent,
  ],
})
export class UtilFileConflictModule { }

export {
  FileConflictService,
  FileConflictOptions,
} from './services/fileConflict.service'
